export default __webpack_public_path__ + "374104b1e40d9883206f0514a8a39f1e.png";